import { SelectOption } from '../models';

export enum SupportType {
  CABINET = 'CABINET',
  RACK = 'RACK',
  NO_SUPPORT = 'NO_SUPPORT',
}

export class SupportTypeHelper {
  private static readonly supportTypeLabelMap: Record<SupportType, string> = {
    [SupportType.CABINET]: 'Cabinet',
    [SupportType.RACK]: 'Rack',
    [SupportType.NO_SUPPORT]: 'No Support',
  };

  static enumToLabelKey(supportType: SupportType): string {
    return this.supportTypeLabelMap[supportType] ?? '';
  }

  private static getConstantList(): SupportType[] {
    return [SupportType.CABINET, SupportType.RACK, SupportType.NO_SUPPORT];
  }

  static getOptions(): SelectOption[] {
    return this.getConstantList().map((supportType) => ({
      label: this.enumToLabelKey(supportType),
      value: supportType,
    }));
  }
}
